import JsBase from './jsbase';

export function getComponent($el, name) {
  if (typeof $el === 'string') {
    $el = document.querySelector($el);
  }
  return JsBase.get($el, name);
}
